module.exports = __webpack_public_path__ + "static/media/omphoenix.279324e8.png";